import { put, takeEvery, call, fork } from 'redux-saga/effects';
import {
	setClaimsListAction,
	setIsClaimsListLoadingAction,
	setPaginationAction,
	GET_CLAIMS_LIST,
	setCountAction,
	GET_CLAIMS_COUNT,
	GET_CLAIM_CATEGORIES,
	GET_CLAIM_PRIORITIES,
	setIsClaimCategoriesLoadingAction,
	setClaimCategoriesAction,
	setIsClaimPrioritiesLoadingAction,
	setClaimPrioritiesAction,
	setIsClaimSectionsLoadingAction,
	setClaimSectionsAction,
	GET_CLAIM_SECTIONS,
} from './actions';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { errorHandler } from '../../api/utils';
import {
	getClaimsRequest,
	getClaimsCountRequest,
	getClaimPrioritiesRequest,
	getClaimCategoriesRequest,
} from '../../api/claims';
import { getCategoriesRequest } from '../../api/requests';

export function* getClaimsListSaga({ payload: { status, searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsClaimsListLoadingAction(true));
			yield put(setClaimsListAction([]));
		}
		const { data, meta, message } = yield call(getClaimsRequest, status, searchQuery);

		if (data) {
			yield put(
				setClaimsListAction(
					data.map(claim => ({
						...claim,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=claims_details&id=${claim.id}&req_id=${
							claim.req?.id
						}`,
						req_link: `?${searchQuery ? `${searchQuery}&` : ''}modal=reqs_details&id=${claim.req?.id}`,
					})),
				),
			);

			if (meta) {
				yield put(setPaginationAction(meta));
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsClaimsListLoadingAction(false));
	}
}
export function* getClaimsCountSaga() {
	try {
		const { data, message } = yield call(getClaimsCountRequest);

		if (data) {
			yield put(setCountAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	}
}

export function* getClaimCategoriesSaga() {
	try {
		yield put(setIsClaimCategoriesLoadingAction(true));

		const { data, message } = yield call(getClaimCategoriesRequest);

		if (data) {
			yield put(setClaimCategoriesAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsClaimCategoriesLoadingAction(false));
	}
}

export function* getClaimPrioritiesSaga() {
	try {
		yield put(setIsClaimPrioritiesLoadingAction(true));

		const { data, message } = yield call(getClaimPrioritiesRequest);

		if (data) {
			yield put(setClaimPrioritiesAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsClaimPrioritiesLoadingAction(false));
	}
}

export function* getClaimSectionsSaga() {
	try {
		yield put(setIsClaimSectionsLoadingAction(true));

		const { data, message } = yield call(getCategoriesRequest, '?receive=all');

		if (data) {
			yield put(setClaimSectionsAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsClaimSectionsLoadingAction(false));
	}
}

export default function* claimsContainerSaga() {
	yield takeEvery(GET_CLAIMS_LIST, getClaimsListSaga);
	yield takeEvery(GET_CLAIMS_COUNT, getClaimsCountSaga);
	yield takeEvery(GET_CLAIM_CATEGORIES, getClaimCategoriesSaga);
	yield takeEvery(GET_CLAIM_PRIORITIES, getClaimPrioritiesSaga);
	yield takeEvery(GET_CLAIM_SECTIONS, getClaimSectionsSaga);
}
